var _excluded = ["href", "title", "openInNewTab", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Link } from '../../../components';
import { useStyleConfig } from '../../../system';
export var LogoWrapper = props => {
  var {
      href,
      title,
      openInNewTab = false,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var styles = useStyleConfig('LogoWrapper');
  var target = openInNewTab ? '_blank' : '_self';
  return /*#__PURE__*/React.createElement(Link, _extends({
    href: href,
    target: target,
    title: title,
    sx: styles
  }, rest), children);
};